<template>
  <v-container fluid ma-0 pa-0>
    <v-row>
      <v-col cols="6" class="pa-0 d-flex align-center justify-center" style="background-color: #f1f4f6">
        <div style="width: 406px">
          <v-img :src="require('@/assets/images/logo_color.png')" width="250px" eager style="margin: auto"></v-img>
          <h2 class="pt-4 pb-4" style="text-align:center;">ドローンファイルサーバ</h2>
          <v-divider class="mb-10"></v-divider>
          <h3 class="text-center">ログイン</h3>
          <v-form v-model="loginForm" ref="loginForm">
            <v-col cols="12" style="padding: 6px 0px;">
              <v-text-field
                  v-model="email"
                  label="メール*"
                  outlined
                  dense
                  hide-details="auto"
                  type="email"
                  :rules="emailRules"
                  prepend-inner-icon="mdi-email-outline"
                  style="padding-top:0px;"
                  counter="50"
                  clearable
              ></v-text-field>
            </v-col>
            <v-col cols="12" style="padding: 6px 0px;">
              <v-text-field
                  v-model="password"
                  label="パスワード*"
                  outlined
                  dense
                  hide-details="auto"
                  :type="showPassword ? 'text' : 'password'"
                  :rules="passRules"
                  prepend-inner-icon="mdi-lock-outline"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="showPassword = !showPassword"
                  counter
                  clearable
              ></v-text-field>
            </v-col>
          </v-form>
          <v-btn color="primary" style="width:100%;" @click="loginByPassword">ログイン</v-btn>
        </div>
      </v-col>
      <v-col cols="6" class="pa-0">
        <v-img src="../assets/images/cover.jpg" height="100vh" class="grey lighten-2"></v-img>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {store} from '../store';

export default {
  name: "Login",
  data() {
    return {
      sharedState: store.state,
      email: null,
      password: null,
      loginForm: null,
      showPassword: false,
      emailRules: [
        value => (!!value && !!value.trim()) || 'メルアドレスを入力してください。',
        value => (!!value && value.length <= 50) || 'メールアドレスの長さは50文字以内にしてください。',
        value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || '有効なメールアドレスを入力してください。'
        }
      ],
      passRules: [
        v => (!!v && !!v.trim()) || 'パスワードを入力してください。',
        v => (!!v && v.length >= 8) || '8文字以上のパスワードを入力してください。',
        v => /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/.test(v) || '大文字1つ、小文字1つ、数字1つを最低限含むパスワードを入力してください。',
      ],
    };
  },

  methods: {
    loginByPassword(){
      if (this.$refs.loginForm.validate()){
        this.axios
            .post('/api/login-by-password/', {email: this.email, password: this.password})
            .then((response) => {
              store.updateLoginStatus(response.data.email, response.data.role, response.data.token);
              this.axios.defaults.headers.common[
                  "Authorization"
                  ] = `Bearer ${response.data.token}`;
              if (this.$route.query.nextUrl != null) {
                this.$router.push(this.$route.query.nextUrl);
              } else {
                this.$router.push("/");
              }
            }).catch(() => {
              store.showErrorDialog("エラーが発生しました。再度試してください。");
            });
      }
    }
  },

  created() {
    if (this.sharedState.email) {
      this.$router.push("/");
    }
  },
};
</script>
